/**
 * Montagem do recorte enviado ao middleware.
 *
 * O filtro não informado precisa **sumir** do objeto, não virar `undefined`
 * explícito: é assim que o cliente da API distingue "não filtrei por isto" de
 * "filtrei por vazio", e é o que o `exactOptionalPropertyTypes` exige.
 *
 * Vale para as quatro listagens do painel — movimentações, dispositivos,
 * usuários e operadores —, para que "todos" no seletor signifique a mesma
 * coisa em todas: a chave não vai na consulta.
 */
export function seInformado<C extends string, V>(
  chave: C,
  valor: V | null | undefined,
): { [K in C]?: V } {
  if (valor === null || valor === undefined) {
    return {};
  }

  // Texto que sobrou da digitação (" SKU-48210 ") vai limpo; texto só de
  // espaços não é filtro nenhum e some.
  if (typeof valor === 'string') {
    const limpo = valor.trim();
    return limpo === '' ? {} : ({ [chave]: limpo } as { [K in C]?: V });
  }

  return { [chave]: valor } as { [K in C]?: V };
}
